import { MDBIcon, MDBInput, MDBInputGroup } from 'mdb-react-ui-kit';
import { InputGroupProps } from 'mdb-react-ui-kit/dist/types/free/forms/InputGroup/types';

export interface SearchInputProps extends InputGroupProps {
    onSearch: (text: string) => void;
}

export const SearchInput = ({ onSearch, style, ...rest }: SearchInputProps) => {
    const mergedStyle = { maxWidth: style?.maxWidth ?? 500, ...style };

    return (
        <MDBInputGroup className="mb-3" noBorder style={mergedStyle} {...rest}>
            <span className="input-group-text bg-white border-end-0">
                <MDBIcon fas icon="search" />
            </span>
            <input
                type="text"
                className="form-control border-start-1"
                placeholder="Search"
                aria-label="Search"
                onInput={(ev) => onSearch(ev.currentTarget.value)}
            />
        </MDBInputGroup>
    );
};
